export default "__VITE_ASSET__DAIOAcqe__"